import { FormControlProps, TextFieldProps } from "@mui/material";
import React from "react";
import { FieldValues } from "react-hook-form";

import { ControllerTextField } from "./ControllerTextField";
import { FormInputWrapper } from "./FormInputWrapper";
import { FieldPathOfType } from "./formTypes";

interface IProps<TFieldValues extends FieldValues, TName extends FieldPathOfType<TFieldValues, string>> {
    name: TName;
    label: string;
    placeholder?: string;
    helperText?: React.ReactNode;
    startAdornment?: React.ReactNode;
    endAdornment?: React.ReactNode;
    required?: boolean;
    disabled?: boolean;
    className?: string;
    defaultValue?: string;
    sx?: FormControlProps["sx"];
    multiline?: boolean;
    minRows?: number;
    size?: TextFieldProps["size"];
}

/**
 * @deprecated Just directly use FormInputWrapper and ControllerTextField.
 */
export function FormTextInput<
    TFieldValues extends FieldValues = FieldValues,
    TName extends FieldPathOfType<TFieldValues, string> = FieldPathOfType<TFieldValues, string>,
>({
    name,
    label,
    placeholder,
    helperText,
    startAdornment,
    endAdornment,
    required,
    disabled,
    defaultValue,
    sx,
    multiline,
    minRows,
    size = "small",
}: IProps<TFieldValues, TName>): React.ReactElement | null {
    return (
        <FormInputWrapper
            name={name}
            required={required}
            disabled={disabled}
            label={label}
            helperText={helperText}
            sx={sx}
        >
            <ControllerTextField
                name={name}
                controllerProps={{ defaultValue: defaultValue as never, rules: { required } }}
                disabled={disabled}
                placeholder={placeholder}
                multiline={multiline}
                size={size}
                minRows={minRows}
                InputProps={{ startAdornment, endAdornment }}
            />
        </FormInputWrapper>
    );
}
